import { render, staticRenderFns } from "./WaitingTimesForm.vue?vue&type=template&id=02742885&scoped=true&"
import script from "./WaitingTimesForm.vue?vue&type=script&lang=js&"
export * from "./WaitingTimesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02742885",
  null
  
)

export default component.exports